import { useMutation, useQueryClient } from "@tanstack/react-query";
import periodidService from "../../services/periodic/PeriodicService";

export const usePostPeriodic = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: {
            taskIds: number[];
            localIds: number[];
            dates: Date[];
        }) =>
            periodidService.PostPeriodic(
                data.taskIds,
                data.localIds,
                data.dates,
            ),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["periodics"] });
        },
    });
};
